// @ts-expect-error - This is how we utilize dynamic imports with WebPack NormalModuleReplacementPlugin (webpack.config.js)
import HaveDocumentQuestion from "./HaveDocumentQuestion-APP_CLIENT.styled";

export default HaveDocumentQuestion;
